import React from 'react';

import { ColumnDescription } from 'react-bootstrap-table-next';
import { FaCaretLeft, FaCaretRight } from 'react-icons/fa/index';
import { Scrollbars } from 'react-custom-scrollbars';

import Navigation from '../../components/navigation/Navigation';
import { ErrorMessage } from '../../components/visuals/Visuals';
import Table from '../../components/Table';
import Multiselect from '../../components/Multiselect';

import { General, Statistics } from '../../lib/dataAccess/DataAccess';

import { GetGraduationPrognosisData } from '../../lib/Statisitcs/GraduationCalculation'
import { GetGraduationPrognosisColumns } from '../../lib/Statisitcs/GraduationPrognosisColumns';
import filterFactory, { textFilter, selectFilter } from 'react-bootstrap-table2-filter';

interface Props {
    role: String
};
interface State {
    error: String | null,
    isLoading: Boolean,
    pageSize: number,
    tableData: any[],
    programColumns: ColumnDescription<any, any>[],
    extendedColumns: ColumnDescription<any, any>[],
    selectedClass?: {label: string, value: number},
    classes: { id: number, name: string, school: { id: number, name: string } | null }[],
    classOptions: { label: string, value: number }[],
    hideIndividualColumns: boolean,
    personalColumns: {
        shownExpandedPersonalColumns: number,
        expandableDirection: number,
        expandablePersonalColumnData: {
            width: number
        }[]
    },
    expandablePersonalColumns: ColumnDescription<any, any>[],
    programType?: string,
    showDropdown: boolean
};

const multiselectOverrideStrings = {
    selectSomeItems: "Välj...",
    allItemsAreSelected: "Alla val är markerade.",
    selectAll: "Välj alla",
    search: "Sök",
    clearSearch: "Töm Sök"
};

export default class GraduationPrognosisPage extends React.Component<Props, State>
{
    constructor(props: Props) 
    {
        super(props)

        this.getClasses = this.getClasses.bind(this);
        this.getGraduationPrognosis = this.getGraduationPrognosis.bind(this);
        this.toggleColumns = this.toggleColumns.bind(this);
        this.togglePersonalColumns = this.togglePersonalColumns.bind(this);
        //this.getEvalColumns = this.getEvalColumns.bind(this);
        
        this.state = {
            error: null,
            isLoading: false,
            pageSize: 20,
            tableData: [],
            programColumns: [],
            extendedColumns: [],
            classes: [],
            classOptions: [],
            hideIndividualColumns: true,
            personalColumns: {
                shownExpandedPersonalColumns: 0,
                expandableDirection: 1,
                expandablePersonalColumnData: []
            },
            expandablePersonalColumns: [],
            programType: undefined,
            showDropdown: true
        }
    }

    componentDidMount() {
        //TODO: Fetch schools and classes
        // Do not need to fetch data before filters are set
        this.getClasses();

        if(this.state.selectedClass !== undefined) {
            this.getGraduationPrognosis();
        }
    }

    async getClasses() {
        try {
            const classes = await General.getClasses();
            const classOptions = classes
                                    .map(c => ({ label: `${c.name}, ${c.school ? c.school.name : ''}`, value: c.id }))
                                    .sort((a, b) => a.label > b.label ? 1 : -1);

            this.setState({ classes, classOptions });
        }
        catch (error) {
            this.setState({error});
        }
    }

    toggleColumns() {
        this.setState(({hideIndividualColumns}) => ({ hideIndividualColumns: !hideIndividualColumns }));
    }

    togglePersonalColumns() {
        const { expandableDirection, shownExpandedPersonalColumns, expandablePersonalColumnData } = this.state.personalColumns;
        const newDirection = expandableDirection == 1 ? 
                                (shownExpandedPersonalColumns + expandableDirection) > expandablePersonalColumnData.length ? -1 : 1
                            : (shownExpandedPersonalColumns + expandableDirection) <= 0 ? 1 : -1;

        this.setState(({personalColumns}) => ({ personalColumns: {
                ...personalColumns,
                shownExpandedPersonalColumns: shownExpandedPersonalColumns + expandableDirection,
                expandableDirection: newDirection
            }}));
    }

    async getGraduationPrognosis() {
        try {
            this.setState({isLoading: true, showDropdown: true});

            const graduationPrognosis = 
                await Statistics.getGraduationPrognosis(
                    this.state.selectedClass !== undefined ? 
                        { classId: this.state.selectedClass.value } 
                    : { classId: -1 });

            var classObj = this.state.classes.find((elem) => elem.id == this.state.selectedClass?.value) || { name: ''};

            const data = GetGraduationPrognosisData(graduationPrognosis, classObj.name);
            const { columns, extendedColumns, expandablePersonalColumns, personalColumnData  } = GetGraduationPrognosisColumns(graduationPrognosis, classObj.name);

            this.setState(({personalColumns}) => ({ 
                tableData: data, 
                programColumns: columns, 
                extendedColumns: extendedColumns,
                expandablePersonalColumns: expandablePersonalColumns,
                personalColumns: {
                    shownExpandedPersonalColumns: 0,
                    expandableDirection: 1,
                    expandablePersonalColumnData: personalColumnData
                }
            }));
        }
        catch (error) {
            console.error(error);
            this.setState({error: error});
        }
    }

    render() {
        const { error, isLoading, programColumns, extendedColumns: individualColumns, tableData, hideIndividualColumns, personalColumns, expandablePersonalColumns } = this.state
        
        const extendedColumns = hideIndividualColumns ? [] : individualColumns;

        const _personalColumns: ColumnDescription<any, any>[] = [{
            dataField: 'socialSecurityNumber',
            text: 'Personnummer',
            headerStyle: {
                width: '10rem',
                left:'16rem',
                zIndex: 10000
            },
            headerClasses: 'sticky-x',
            classes: 'sticky-x',
            style: {
                wordBreak: 'break-word',
                left:'16rem',
                zIndex: 10000
            }
        }, ...expandablePersonalColumns];

        const {arr, total} = personalColumns.expandablePersonalColumnData.reduce((acc: { arr: number[], total: number}, elem: { width: number }) => (
                { arr: [...acc.arr, (elem.width + acc.total)], total: elem.width + acc.total }
            ), 
            { arr: [16, 26], total: 26 }
        );

        const personalColumnDescriptions: ColumnDescription<any, any>[] = [..._personalColumns.map((c: ColumnDescription<any, any>, i: number) => ({...c, hidden: i >= personalColumns.shownExpandedPersonalColumns})),
            {
                dataField: 'expandCollapsePersonal',
                text: '',
                isDummyField: true,
                formatter: () => (
                    <div style={{textAlign: 'center', verticalAlign: 'middle', height: '100%', width:'100%', display: 'table'}} onClick={this.togglePersonalColumns}>
                        <div style={{verticalAlign: 'middle', display: 'table-cell'}}>
                            {personalColumns.expandableDirection == 1 ? <FaCaretRight /> : <FaCaretLeft/>}
                        </div>
                    </div>),
                style: {
                    textAlign: 'right',
                    backgroundColor: '#dee2e6',
                    verticalAlign: 'middle',
                    borderColor: '#dee2e6',
                    color: '#2D2D2D',
                    cursor: 'pointer',
                    padding: '0',
                    height: 'inherit',
                    left: arr[personalColumns.shownExpandedPersonalColumns] + 'rem',
                    zIndex: 10000
                },
                headerStyle: {
                    width: '2rem',
                    left: arr[personalColumns.shownExpandedPersonalColumns] + 'rem',
                    zIndex: 10000
                },
                headerClasses: 'sticky-x',
                classes: 'sticky-x'
            }

        ];

        const columns : ColumnDescription<any, any>[] = [
            {
                dataField: 'dataIndex',
                text: 'INDEX',
                hidden: true
            }, {
                dataField: 'gender',
                text: 'Kön',
                headerStyle: {
                    width: '6rem',
                    textAlign: 'center',
                    zIndex: 10000
                },
                headerClasses: 'sticky-x',
                classes: 'sticky-x',
                sort: true,
                style: {
                    textAlign: 'center',
                    zIndex: 10000
                },
                headerFormatter: ((c, i, { filterElement }) => <div style={{}}>
                    {filterElement}
                    {'Kön'}
                </div>),
                filter: selectFilter({
                    placeholder: 'Filtrera',
                    options: { M: 'M', K: 'K'},
                    style: {
                        position: 'absolute',
                        /* top: 50%; */
                        left: '10%',
                        width: '80%',
                        bottom: '3rem'
                    }
                }),
                //filter: textFilter()
            }, {
                dataField: 'name',
                text: 'Namn',
                headerStyle: {
                    width: '10rem',
                    left:'6rem',
                    zIndex: 10000
                },
                headerClasses: 'sticky-x',
                classes: 'sticky-x',
                style: {
                    wordBreak: 'break-word',
                    left:'6rem',
                    zIndex: 10000
                },
                filter: textFilter({
                    placeholder: 'Sök...',
                    style: {
                        position: 'absolute',
                        /* top: 50%; */
                        left: '10%',
                        width: '80%',
                        bottom: '3rem'
                    }
                }),
                sort: true
            },
            ...personalColumnDescriptions,
            ...programColumns, 
            //...(this.getEvalColumns()),
            ...extendedColumns, 
            {
                dataField: 'expandCollapse',
                text: '',
                isDummyField: true,
                formatter: () => (
                    <div style={{textAlign: 'center', verticalAlign: 'middle', height: '100%', width:'100%', display: 'table'}} onClick={this.toggleColumns}>
                        <div style={{verticalAlign: 'middle', display: 'table-cell'}}>
                            {hideIndividualColumns ? <FaCaretRight /> : <FaCaretLeft/>}
                        </div>
                    </div>),
                /*headerFormatter: () => (
                    <div style={{textAlign: 'center', verticalAlign: 'middle', height: '100%', width:'100%', display: 'table'}} onClick={this.toggleColumns}>
                        <div style={{verticalAlign: 'middle', display: 'table-cell'}}>
                            {hideIndividualColumns ? <FaCaretRight /> : <FaCaretLeft/>}
                        </div>
                    </div>),*/
                style: {
                    textAlign: 'right',
                    backgroundColor: '#dee2e6',
                    verticalAlign: 'middle',
                    borderColor: '#dee2e6',
                    color: '#2D2D2D',
                    cursor: 'pointer',
                    padding: '0',
                    height: 'inherit'
                },
                headerStyle: {
                    width: '2rem',
                },
                headerClasses: 'sticky-y'
            }
        ];

        return (
            <div className="render-graduation-prognosis">
                <Navigation role={this.props.role}/>
                <div className="junit-container container-fit" style={{overflow:'auto'}}>
                    <ErrorMessage hidden={error === null} style={{marginBottom:'1rem'}}>{error}</ErrorMessage>
                    <br/>
                    {this.state.showDropdown ?
                        <Multiselect 
                            value={this.state.selectedClass ? [this.state.selectedClass] : []}
                            onChange={(selected: any) => {
                                    if(selected.length > 0) {
                                        this.setState(
                                            {
                                                selectedClass: selected[selected.length - 1], 
                                                showDropdown: false
                                            },
                                            this.getGraduationPrognosis
                                        )
                                    }}}
                            options={this.state.classOptions}
                            ItemRenderer={({
                                checked,
                                option,
                                onClick,
                                disabled,
                            }: {
                                checked: boolean,
                                option: {
                                    value: any;
                                    label: string;
                                    key?: string;
                                    disabled?: boolean;
                                    header?: boolean;
                                },
                                disabled?: boolean,
                                onClick(event?: React.ChangeEvent<HTMLInputElement>) : void}) => {
                                    if(option.header) {
                                        return (<div className={'multiselect-dropdown-header'}>
                                            <span>{option.label}</span>
                                        </div>);
                                    }
                                    return (<div className={`item-renderer ${disabled ? " disabled" : ""}`} /*onClick={() => onClick()}*/>
                                    <input
                                        type="checkbox"
                                        onChange={onClick}
                                        checked={checked}
                                        tabIndex={-1}
                                        disabled={disabled}
                                        hidden
                                    />
                                        <span  style={{paddingLeft: '5px'}}>{option.label}</span>
                                    </div>);
                                }
                            }
                            maxResult={1000}
                            ClearSelectedIcon={' '}
                        />
                    : null}
                    <br/>
                    <div className="graduation-table-container">
                        <div>
                            <Table 
                                keyField={"id"} 
                                columns={columns} 
                                data={tableData} 
                                loading={isLoading} 
                                searchHidden 
                                csvExport={true}
                                //pageSize={this.state.pageSize}
                                //menuField={ menuField }
                                bsTableProps={{ rowStyle: {
                                        height: '1px'
                                    },
                                    defaultSorted: [{dataField:'gender', order: 'asc'}],
                                    headerClasses: 'OnePxHeight',
                                    filter: filterFactory()
                                }}
                            />
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}
